import { useEffect, useState } from "react";
import { Input } from "../../../components/ui/input";
import { invitationService } from "../../../services/invitationService";
import { Button } from "../../../components/ui/button";
import { Navigate, useNavigate, useParams } from "react-router-dom";

export default function JoinCommunity() {
  const [selectedProfile, setSelectedProfile] = useState("");
  const [newProfileName, setNewProfileName] = useState("");
  const [profileNames, setProfileNames] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { mode } = useParams();
  console.log("mode", mode);

  useEffect(() => {
    const storedProfiles = sessionStorage.getItem("userProfiles");
    if (storedProfiles) {
      try {
        const parsedProfiles = JSON.parse(storedProfiles);
        const names = parsedProfiles.map((p) => p.name);
        setProfileNames(names);
        setProfiles(parsedProfiles); // Full objects for lookup later
        setSelectedProfile(names[0] || ""); // Default selection
      } catch (err) {
        console.error("Failed to parse userProfiles from sessionStorage", err);
      }
    }
  }, []);

  if (!["invitation", "reassign"].includes(mode)) {
    return <Navigate to="/not-found" />;
  }

  const token = sessionStorage.getItem("invitationToken");
  const entityId = sessionStorage.getItem("userId");

  console.log("token and entityId: ", token, entityId);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = sessionStorage.getItem("invitationToken");
    const entityId = sessionStorage.getItem("userId");

    if (!token || !entityId) {
      console.error("Missing required session data.");
      return;
    }

    let requestPayload = {
      Token: token,
      Name: "",
      ProfileId: null,
      EntityId: entityId,
    };

    if (selectedProfile === "Create New Profile") {
      if (!newProfileName.trim()) {
        alert("Please enter a profile name.");
        return;
      }
      requestPayload.Name = newProfileName.trim();
    } else {
      const selected = profiles.find((p) => p.name === selectedProfile);
      if (!selected) {
        console.error("Selected profile not found.");
        return;
      }
      // requestPayload.Name = selected.name;
      requestPayload.ProfileId = selected.profileId || null;
    }

    try {
      setLoading(true);

      // Call the correct API based on mode
      let result;
      if (mode === "invitation") {
        result = await invitationService.invitationAddProfile(requestPayload);
      } else if (mode === "reassign") {
        result = await invitationService.reassignAddProfile(requestPayload);
      }

      console.log("Profile successfully added:", result);
      navigate("/invitesuccess");
    } catch (error) {
      console.error("Failed to add profile:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-teal-500 relative">
      {/* Background Bubbles */}
      <div className="absolute w-72 h-72 bg-white opacity-10 rounded-full top-10 left-10"></div>
      <div className="absolute w-96 h-96 bg-white opacity-10 rounded-full bottom-10 right-10"></div>
      <div className="absolute w-96 h-96 bg-white opacity-10 rounded-full top-12 center"></div>

      <div className="bg-white p-8 rounded-2xl shadow-lg w-96 z-10">
        <div className="text-center mb-6">
          <h1 className="text-xl font-semibold">Join Our Community</h1>
          <p className="text-md">Choose a profile as community admin</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="space-y-3 mb-4">
            {profileNames.map((profile) => (
              <div key={profile} className="flex items-center">
                <input
                  type="radio"
                  id={profile}
                  name="profile"
                  value={profile}
                  checked={selectedProfile === profile}
                  onChange={() => setSelectedProfile(profile)}
                  className="mr-2"
                />
                <label htmlFor={profile}>{profile}</label>
              </div>
            ))}
            <div className="flex items-center">
              <input
                type="radio"
                id="createNew"
                name="profile"
                value="Create New Profile"
                checked={selectedProfile === "Create New Profile"}
                onChange={() => setSelectedProfile("Create New Profile")}
                className="mr-2"
              />
              <label htmlFor="createNew">Create New Profile</label>
            </div>
            <Input
              type="text"
              placeholder="Enter Profile Name"
              disabled={selectedProfile !== "Create New Profile" || loading}
              value={newProfileName}
              onChange={(e) => setNewProfileName(e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </form>
      </div>
    </div>
  );
}
